import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
  Grid,
  Chip,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import {
  getTypeLabel,
  getStatusLabel,
  formatDate,
} from "../constants";
import { formatDateOnly } from "../utils/form-helpers";
import {
  getVideoEmbedUrl,
  isEmbeddableVideoUrl,
  resolveVideoSourceFromContent,
} from "../utils/video-helpers";

export default function DialogVisualizar({ open, onClose, entity, isCampaign }) {
  if (!entity) return null;

  const titulo = isCampaign ? entity.Nome : entity.Titulo;
  const thumbnail = entity.UrlThumbnail;
  const arquivo = isCampaign ? entity.UrlBannerPrincipal : entity.UrlArquivo;
  const videoUrl = entity.UrlExterna;
  const isVideo = !isCampaign && entity.Tipo === "Video";
  const videoSource = isVideo ? resolveVideoSourceFromContent(entity) : null;
  const embedUrl = videoUrl && isEmbeddableVideoUrl(videoUrl)
    ? getVideoEmbedUrl(videoUrl)
    : videoUrl;

  const renderMedia = () => {
    if (isVideo && videoSource === "link" && embedUrl) {
      return (
        <Box position="relative" paddingTop="56.25%">
          <iframe
            title={titulo}
            src={embedUrl}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: 0,
              borderRadius: 8,
            }}
            allowFullScreen
          />
        </Box>
      );
    }

    if (isVideo && videoSource === "upload" && arquivo) {
      return (
        <video
          controls
          src={arquivo}
          poster={thumbnail || undefined}
          style={{
            width: "100%",
            maxHeight: 360,
            borderRadius: 8,
            backgroundColor: "#000",
          }}
        >
          Seu navegador não suporta reprodução de vídeo.
        </video>
      );
    }

    if (thumbnail || arquivo) {
      return (
        <img
          src={thumbnail || arquivo}
          alt={titulo}
          style={{
            width: "100%",
            maxHeight: 320,
            objectFit: "cover",
            borderRadius: 8,
          }}
        />
      );
    }

    return null;
  };

  const media = renderMedia();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
      <DialogTitle>
        <Typography variant="h4" style={{ color: themeColorsDesingSystem.text.primary }}>
          {titulo}
        </Typography>
        <IconButton
          onClick={onClose}
          style={{ position: "absolute", right: 8, top: 8 }}
          aria-label="Fechar"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          {isVideo && (
            <Grid item xs={12}>
              <Chip
                size="small"
                label={
                  videoSource === "link"
                    ? "Vídeo por link externo"
                    : "Vídeo por upload"
                }
                style={{
                  backgroundColor:
                    videoSource === "link"
                      ? themeColorsDesingSystem.secondary?.main + "33"
                      : themeColorsDesingSystem.orange?.background,
                  color: themeColorsDesingSystem.text.primary,
                }}
              />
            </Grid>
          )}
          {media && <Grid item xs={12}>{media}</Grid>}
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" style={{ color: themeColorsDesingSystem.gray.dark }}>
              Tipo
            </Typography>
            <Typography variant="body2">
              {isCampaign ? "Campanha" : getTypeLabel(entity.Tipo)}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" style={{ color: themeColorsDesingSystem.gray.dark }}>
              Status
            </Typography>
            <Typography variant="body2">{getStatusLabel(entity.Status)}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" style={{ color: themeColorsDesingSystem.gray.dark }}>
              Categoria
            </Typography>
            <Typography variant="body2">{entity.NomeCategoria || "-"}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" style={{ color: themeColorsDesingSystem.gray.dark }}>
              Período
            </Typography>
            <Typography variant="body2">
              {formatDateOnly(isCampaign ? entity.DataInicio : entity.DataInicioVigencia) || "-"}
              {" — "}
              {formatDateOnly(isCampaign ? entity.DataFim : entity.DataFimVigencia) || "-"}
            </Typography>
          </Grid>
          {isVideo && videoSource === "link" && videoUrl && (
            <Grid item xs={12}>
              <Typography variant="caption" style={{ color: themeColorsDesingSystem.gray.dark }}>
                Link do vídeo
              </Typography>
              <Typography variant="body2" style={{ wordBreak: "break-all" }}>
                {videoUrl}
              </Typography>
            </Grid>
          )}
          {entity.Descricao && (
            <Grid item xs={12}>
              <Typography variant="caption" style={{ color: themeColorsDesingSystem.gray.dark }}>
                Descrição
              </Typography>
              <Typography variant="body2">{entity.Descricao}</Typography>
            </Grid>
          )}
          {entity.Tags?.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="caption" style={{ color: themeColorsDesingSystem.gray.dark }}>
                Tags
              </Typography>
              <Typography variant="body2">{entity.Tags.join(", ")}</Typography>
            </Grid>
          )}
          {arquivo && (!isVideo || videoSource === "upload") && (
            <Grid item xs={12}>
              <Button
                variant="outlined"
                color="primary"
                component="a"
                href={arquivo}
                target="_blank"
                rel="noopener noreferrer"
              >
                Abrir arquivo
              </Button>
            </Grid>
          )}
          <Grid item xs={12} sm={6}>
            <Typography variant="caption" style={{ color: themeColorsDesingSystem.gray.dark }}>
              Atualizado em
            </Typography>
            <Typography variant="body2">
              {formatDate(entity.DataAtualizacao || entity.DataInclusao)}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ padding: "16px 24px" }}>
        <Button onClick={onClose} variant="outlined">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
